import elLocale from 'element-ui/lib/locale/lang/en';

export default {
	// Element UI built-in strings (message box, table, form defaults, ...)
	el: elLocale.el,

	common: {
		loading: 'Loading...',
		error: 'Error',
		warning: 'Warning',
		ok: 'OK',
		cancel: 'Cancel',
		close: 'Close',
		save: 'Save',
		saving: 'Saving...',
		add: 'Add',
		adding: 'Adding...',
		create: 'Create',
		creating: 'Creating...',
		delete: 'Delete',
		deleting: 'Deleting...',
		invite: 'Invite',
		inviting: 'Inviting...',
		send: 'Send',
		sending: 'Sending...',
		reset: 'Reset',
		previous: 'Previous',
		next: 'Next',
		select: 'Select',
		or: 'OR',
		name: 'Name',
		description: 'Description',
		email: 'Email',
		password: 'Password',
		firstName: 'First Name',
		lastName: 'Last Name',
		actions: 'Actions',
		status: 'Status',
		signIn: 'Sign in',
	},

	nav: {
		dashboard: 'Dashboard',
		whiteLabel: 'White-label',
		teams: 'Teams',
		users: 'Users',
		update: 'Update',
		welcome: 'Welcome',
		signIn: 'Sign in',
		signUpTo: 'Sign up to',
		stripePlayground: 'Stripe Playground',
	},

	main: {
		expandMenu: 'Expand Menu',
		collapseMenu: 'Collapse Menu',
		helpTooltip: 'Contact the support team to get help or leave us a feedback',
		helpAndFeedback: 'Help and Feedback',
		greeting: 'Hi {name}!',
		profile: 'Profile',
		billing: 'Billing',
		logout: 'Log out',
		downloadInstallers: 'Download installers',
		licenseProblem: 'License Problem',
		licenseProblemText:
			'Either your subscription is canceled, expired or has an issue, please go to the Billing Portal to fix it.',
		noPaymentMethod: 'No payment method attached',
		noPaymentMethodText:
			'Please add a debit or credit card in the billing portal to continue using the Enterprise plan after trial ends.',
		goToBillingPortal: 'Go to Billing Portal',
		trialPeriod: 'Trial period',
		trialEnds: 'Your trial period ends {when}',
		loadingPleaseWait: 'Loading, please wait...',
		loadingBillingPortal: 'Loading billing portal...',
		workspaceError: 'There has been a problem while loading your workspace. Please, try to log in again.',
		redirecting: 'Redirecting to your organization...',
	},

	welcome: {
		privacyPolicy: 'Privacy Policy',
		termsOfUse: 'Terms of Use',
		emailPromptTitle: 'Email invitation',
		emailPromptMessage: 'Please confirm your e-mail address',
		invalidEmail: 'Invalid Email',
	},

	organization: {
		enterprise: 'Enterprise',
		signIn: 'Sign in',
		signInTo: 'Sign in to {name}',
		enterpriseOnly: 'For companies with an Enterprise subscription only.',
		yourTeamUrl: 'Your Team URL',
		urlPlaceholder: 'your-company',
		createOrganization: 'Is your company new on Rambox? Create an organization',
		signUpFree: 'Are you an individual? Sign up for FREE',
	},

	signIn: {
		signInTo: 'Sign in to',
		continueWithGoogle: 'Continue with Google',
		continueWithFacebook: 'Continue with Facebook',
		continueWithMicrosoft: 'Continue with Microsoft',
		emailPlaceholder: 'E-mail',
		passwordPlaceholder: 'Password',
		forgotPassword: 'Forgot password?',
		changeOrganization: 'Change organization',
		authenticating: 'Authenticating...',
		gettingOrganizationInfo: 'Getting Organization Info...',
		sendingResetEmail: 'Sending reset password email...',
		verifyEmail: 'Please verify your account by clicking the link we sent you to {email} before get logged.',
		providerLinked: '{provider} linked to {email}',
		noTenantId: 'The organization is not properly configured.',
		validation: {
			emailRequired: 'E-mail address is required.',
			emailInvalid: 'Please input a correct email address.',
			passwordRequired: 'Password is required.',
			passwordMin: 'Minimum Password length is 6.',
		},
		resetPrompt: {
			title: 'Forgot Password',
			message: 'Please input your e-mail.',
			invalidEmail: 'Invalid e-mail format.',
			sent: 'A reset password email has been sent to {email}',
		},
	},

	signUp: {
		signUpTo: 'Sign up to',
		userCreated: 'Your user has been created!',
		validation: {
			firstNameRequired: 'Please input first name',
			lastNameRequired: 'Please input last name',
			passwordRequired: 'Password is required.',
			passwordMin: 'Minimum Password length is 6.',
			confirmRequired: 'Confirmation is required.',
			passwordsDoNotMatch: 'The passwords don’t match!',
		},
		confirm: 'Confirm',
	},

	create: {
		steps: {
			company: 'Company information',
			personal: 'Your information',
			password: 'Password',
			summary: 'Summary',
		},
		intro:
			'You are about to create an Enterprise account. This type of account is {bold}. If you are an individual, please {link}.',
		introBold: 'only for companies',
		introLink: 'sign up for FREE here',
		companyInfo: 'Please enter your company information.',
		personalInfo: 'Please enter your personal information.',
		passwordInfo: 'Please enter the password for your admin account.',
		company: 'Company',
		companyPlaceholder: 'Your Company name',
		url: 'URL',
		urlPlaceholder: 'company-domain',
		workEmail: 'Work email',
		workEmailPlaceholder: 'Your work email',
		firstNamePlaceholder: 'First name',
		lastNamePlaceholder: 'Last name',
		confirm: 'Confirm',
		companyName: 'Company name',
		companyUrl: 'Company URL',
		adminFirstName: 'Admin First name',
		adminLastName: 'Admin Last name',
		adminEmail: 'Admin e-mail',
		adminPassword: 'Admin Password',
		createButton: 'Create!',
		selectTeam: 'Select team',
		creating: 'Creating your organization. Please wait...',
		validation: {
			firstNameRequired: 'First name is required.',
			lastNameRequired: 'Last name is required.',
			emailRequired: 'Please input an email address',
			companyNameRequired: 'Please input your Company name',
			urlRequired: 'Please input your desired URL',
			urlTaken: 'This URL is already taken',
			urlForbidden: 'This URL is forbidden',
			minLength4: 'Minimum length is 4.',
			maxLength20: 'Maximum length is 20.',
			urlFormat: 'The URL should start with a letter and only consist of letters, digits & hyphens',
			passwordRequired: 'Password is required.',
			passwordMin: 'Minimum Password length is 6.',
			confirmRequired: 'Confirmation is required.',
			passwordsDoNotMatch: 'The passwords don’t match!',
			workEmailInvalid: 'Please input a valid work email address',
			notCompanyEmail: 'Company email required: {email} is not a company email',
			disposableEmail: 'Disposable email detected: {email} is not allowed',
		},
	},

	gettingStarted: {
		welcomeTo: 'Welcome to',
		downloadToStart: 'Download Rambox to get started',
		selectOs: 'Please, select your Operating System to download the installer.',
		doubleClick: 'To start the installation process, double-click on the downloaded file.',
		enterpriseHint:
			'Once you start Rambox, be sure to select the Enterprise login option and enter the following domain URL:',
		downloadInstaller: 'Download installer',
		gettingOrganizationInfo: 'Getting Organization Info...',
	},

	dashboard: {
		// Readers already have Teams: this invites them to move to v3, it doesn't sell Teams. v2 "areas and roles"
		// are v3 "teams and sub-teams". The lead and the
		// features come from shipped v3 copy (console migration wizard, desktop "What's new" tour).
		v3: {
			title: 'Rambox 3 is here',
			lead:
				"We've rebuilt Rambox from the ground up. Your areas and roles move over as teams and sub-teams, and no one gets signed out. It takes a minute and is done once, for everyone.",
			plus: 'Everything you have today, plus:',
			groups: {
				team: 'For your team',
				admins: 'For admins',
			},
			features: {
				search: 'Unified Search across apps',
				ai: 'AI assistants in a side panel',
				focus: 'Focus sessions',
				permissions: 'Permissions per team and sub-team',
				memberPermissions: 'Custom permissions per member',
				theme: 'A theme from your brand colors',
			},
			migrate: 'Migrate to v3',
			demo: 'Request a demo',
		},
		totalUsers: 'Total users',
		pendingInvitations: 'Pending Invitations',
		nextInvoiceDate: 'Next Invoice Date',
		nextInvoice: 'Next Invoice',
	},

	teams: {
		selectTeamHint: 'Please select a team',
		workspacesFrom: 'Workspaces from "{name}" team',
		popoverTitle: 'What are teams and workspaces?',
		popoverContent:
			"A workspace is a set of apps organized into groups that you can assign to users to use them inside Rambox. A team is a set of workspaces for a better management. Ex: 'HR' can by a team and 'Hiring' is a workspace.",
		team: 'Team',
		workspace: 'Workspace',
		editGroup: 'Edit group',
		deleteGroup: 'Delete group',
		viewWorkspace: 'View workspace',
		editWorkspace: 'Edit workspace',
		deleteWorkspace: 'Delete workspace',
		newTeam: 'New Team',
		editTeam: 'Edit Team',
		newWorkspace: 'New Workspace',
		editWorkspaceTitle: 'Edit Workspace',
		newFallback: 'New',
		validation: {
			nameRequired: 'Please input a name',
			nameTaken: 'This name is already taken',
			descriptionRequired: 'Please input a description',
		},
		groupCreated: 'Group created successfully!',
		groupEdited: 'Group edited successfully!',
		groupDeleted: 'Group deleted successfully!',
		workspaceAdded: 'Workspace added to {name}',
		workspaceEdited: 'Workspace edited successfully!',
		workspaceDeleted: 'Workspace deleted successfully!',
		usersInGroup: 'There are users in this group. Please, move them to another group and then remove this one.',
		usersWithWorkspace:
			'There are users with this workspace. Please, assign them another workspace and then remove this one.',
		deleteGroupConfirm: 'This will permanently delete "{name}" and all its workspaces. Continue?',
		deleteWorkspaceConfirm: 'This will permanently delete "{name}" workspace. Continue?',
		deleteWorkspaceSimple: 'This will delete the workspace. Continue?',
	},

	users: {
		popoverTitle: 'Invite your teammates',
		popoverContent:
			'You can give permissions to allow or disallow them to add new groups and apps into Rambox, and classify them into groups and sub-groups for a better management.',
		team: 'Team',
		workspace: 'Workspace',
		permission: 'Permission',
		viewWorkspace: 'View Workspace',
		editUser: 'Edit User',
		resendInvitation: 'Resend Invitation',
		deleteThisUser: 'Delete this user',
		newUser: 'New User',
		editUserTitle: 'Edit User',
		permissionsTitle: 'Type of permissions',
		permissionsContent:
			'Full: The user will be able to create the workspace without restrictions. Intermediate: Will inherit the workspace configuration but will be able to add new groups and apps. Basic: Will only use the apps configured in the workspace.',
		permissions: {
			full: 'Full',
			intermediate: 'Intermediate',
			basic: 'Basic',
		},
		admin: 'Admin',
		adminOf: 'Admin of {name}',
		support: 'Support',
		showSection: 'show section',
		notShowSection: 'NOT show section',
		tags: {
			admin: 'ADMIN',
			pending: 'PENDING',
			active: 'ACTIVE',
			inactive: 'INACTIVE',
		},
		validation: {
			emailRequired: 'Please input an email address',
			emailInvalid: 'Please input correct email address',
			emailTaken: 'This email is already taken',
			firstNameRequired: 'Please input first name',
			lastNameRequired: 'Please input last name',
			permissionRequired: 'Please select a permission',
			teamRequired: 'Please select a team',
			workspaceRequired: 'Please select a workspace',
		},
		emailSent: 'Email successfully sent!',
		userEdited: 'User edited',
		deleteCompleted: 'Delete completed',
		resendTitle: 'Resend Invitation',
		resendMessage: 'This will resend the email invitation. Continue?',
		deleteUserTitle: 'Delete user',
		deleteInvitationTitle: 'Delete invitation',
		deleteUserConfirm: 'This will permanently delete "{name}" and all its workspace. Continue?',
		deleteInvitationConfirm: 'This will delete the "{email}" invitation. Continue?',
		basicPermissionWarning: 'Changing to "Basic" permission will delete the user workspace. Continue?',
	},

	whiteLabel: {
		popoverTitle: 'What can I do here?',
		popoverContent: 'Here you will be able to customize Rambox app and the admin to use your company colors and logo.',
		settings: 'Settings',
		organizationName: 'Organization name',
		namePlaceholder: 'Name',
		logo: 'Logo',
		setToDefault: 'Set to default',
		customizeLayout: 'Customize the layout with your colors',
		light: 'Light',
		dark: 'Dark',
		primary: 'Primary',
		backgroundColor: 'Background color',
		titlebar: 'Titlebar',
		saveConfirmTitle: 'Save changes',
		saveConfirmMessage: 'This will permanently override your previous configuration. Continue?',
		saved: 'Configuration successfully saved',
	},

	workspaces: {
		title: 'Workspace configuration',
		addGroup: 'Add group',
		addApp: 'Add app',
		addNewGroup: 'Add a new group',
		addNewApp: 'Add a new app',
		editApp: 'Edit App',
		editGroup: 'Edit Group',
		deleteApp: 'Delete App',
		deleteGroup: 'Delete Group',
		configurationRequired: 'Configuration required',
		workspaceTag: 'WORKSPACE',
		affectsUsers: 'This change will affect all the users using this workspace.',
		deleteGroupConfirm: 'This will permanently delete the "{name}" group and all its apps. Continue?',
		deleteAppConfirm: 'This will permanently delete the "{name}" app. Continue?',
		deleteAppTitle: 'Delete app',
		deleteGroupTitle: 'Delete group',
		deleteCompleted: 'Delete completed',
	},

	appConfig: {
		newApp: 'New App',
		editApp: 'Edit App',
		roleWarning: 'This change will affect all the users of this role.',
		step1: 'Step 1',
		step2: 'Step 2',
		editIcon: 'Edit',
		setDefaultIcon: 'Set default',
		visitWebsite: 'Visit website',
		url: 'URL',
		urlOption: 'Option {index}',
		profile: 'Profile',
		linkHandling: 'Link Handling',
		advanced: 'Advanced',
		advancedWarning:
			'The following options may cause security problems, use them responsibly. To apply any of the options, you need to restart the app.',
		injectJs: 'Inject JavaScript Code',
		injectCss: 'Inject CSS Code',
		pleaseInput: 'Please input',
		userAgent: 'User Agent',
		hibernate: 'Hibernate',
		after: 'After',
		minutes: 'minutes',
		hibernateHint: 'Leave it in 0 to deactivate this feature',
		startHibernated: 'Start hibernated',
		proxy: 'Proxy',
		type: 'Type',
		needsRelaunch: '(needs to relaunch)',
		host: 'Host',
		hostPlaceholder: 'URL or IP',
		port: 'Port',
		username: 'Username',
		forceMobile: 'Force Mobile Rendering',
		validation: {
			nameRequired: 'Please input a app name',
			urlInvalid: 'Please insert a valid URL',
			urlValid: 'Please enter a valid URL',
			valueRequired: 'Please enter a value',
		},
		appEdited: 'App edited',
		appCreated: 'App created',
	},

	appList: {
		customApp: 'Custom App',
		search: 'Search...',
		noResults: 'No apps matching your search... but you can add it using "Custom App" option above!',
	},

	groupConfig: {
		newGroup: 'New group',
		editGroup: 'Edit group',
		sharedHint: 'This group will be added to the user workspace, to share it use the Teams section',
		affectsUsers: 'This change will affect all users sharing this workspace.',
		namePlaceholder: 'Example: Personal, Work, Messengers, Emails...',
		selectIcon: 'Select an icon',
		profile: 'Profile',
		validation: {
			titleRequired: 'Please input a title',
		},
		groupEdited: 'Group edited',
		groupCreated: 'Group created',
	},

	profile: {
		title: 'Profile',
		changePassword: 'Change Password',
		changePasswordTitle: 'Change password',
		currentPassword: 'Current Password',
		newPassword: 'New Password',
		confirmNewPassword: 'Confirm New Password',
		validation: {
			firstNameRequired: 'First name is required.',
			lastNameRequired: 'Last name is required.',
			emailRequired: 'Please input an email address',
			emailInvalid: 'Please input correct email address',
			currentPasswordRequired: 'Current password is required.',
			passwordMin: 'Minimum Password length is 6.',
			newPasswordRequired: 'New password is required.',
			confirmNewRequired: 'Confirmation of new password is required.',
			newPasswordsDoNotMatch: 'The new passwords don’t match!',
		},
		userEdited: 'User edited',
		passwordChanged: 'Password successfully changed',
	},

	themePreviewer: {
		editGmail: 'Edit Gmail',
	},

	update: {
		outdated: 'You are running an outdated version, please update...',
		goToMenu: 'Go to Menu, Help, About Rambox and update to latest version',
		orDownload: 'or download the installer from rambox.app',
	},

	store: {
		emailInvitationError: 'Something went wrong while sending email invitation',
	},

	// Firebase error codes. Any code not listed here falls back to the raw
	// message returned by Firebase.
	firebase: {
		'auth/invalid-email': 'The email address is not valid.',
		'auth/user-disabled': 'This account has been disabled. Please contact support.',
		'auth/user-not-found': 'There is no account with this email address.',
		'auth/wrong-password': 'The email or the password is incorrect.',
		'auth/invalid-credential': 'The email or the password is incorrect.',
		'auth/invalid-login-credentials': 'The email or the password is incorrect.',
		'auth/missing-password': 'Please enter your password.',
		'auth/email-already-in-use': 'There is already an account with this email address.',
		'auth/weak-password': 'The password is too weak. Use at least 6 characters.',
		'auth/operation-not-allowed': 'This sign in method is not enabled.',
		'auth/too-many-requests': 'Too many attempts. Please wait a few minutes and try again.',
		'auth/network-request-failed': 'Network error. Please check your connection and try again.',
		'auth/popup-closed-by-user': 'The sign in window was closed before finishing.',
		'auth/cancelled-popup-request': 'The sign in request was cancelled.',
		'auth/requires-recent-login': 'Please sign in again to complete this action.',
		'auth/expired-action-code': 'This link has expired. Please request a new one.',
		'auth/invalid-action-code': 'This link is invalid or has already been used.',
		'auth/account-exists-with-different-credential':
			'There is already an account with this email address using a different sign in method.',
		'auth/internal-error': 'Something went wrong. Please try again.',
	},
};
